import { useEffect, useRef } from "react";

export const usePrevious = <T,>(value: T) => {
  const ref = useRef<T | undefined>(undefined);

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  // oxlint-disable-next-line react/react-compiler -- FIXME(CLI-289): auto-suppressed during shared-config migration.
  return ref.current;
};
